export interface InformationRequestItem {
  informationRequestEntityId: string | null;
  informationRequestId: string | null;
  status: InformationRequestStatus | null;
  question: string | null;
  answer: string | null;
  itemsCount: number | null;
  createdOn: Date | string | null;
  updatedOn: Date | string | null;
  technicalEngineerEntityId: string | null;
  technicalEngineer: string | null;
  updatedByEntityId: string | null;
  updatedBy: string | null;
  technicalEngineerEntityId2: string | null;
  technicalEngineer2: string;
  technicalEngineerEntityId3: string | null;
  technicalEngineer3: string;
  technicalEngineerEntityId4: string | null;
  technicalEngineer4: string;
  allTechnicalEngineers: string | null;
}

export interface InformationRequest {
  informationRequestEntityId: string;
  informationRequestId: string;
  status: number;
  question: string | null;
  answer: string | null;
  itemsCount: number | null;
  createdOn: string | Date;
  updatedOn: string | Date;
  technicalEngineerEntityId: string | null;
  technicalEngineer: string;
  lastCommentedByEntityId: string;
  lastCommentedBy: string;
  technicalEngineerEntityId2: string | null;
  technicalEngineer2: string;
  technicalEngineerEntityId3: string | null;
  technicalEngineer3: string;
  technicalEngineerEntityId4: string | null;
  technicalEngineer4: string;
}

export interface TechnicalEngineer {
  id: string;
  fullname: string;
  emailAddress: string;
}

export interface ReassignRequestBody {
  technicalEngineerEntityIds: string[];
  reassignmentReason: string;
  informationRequestEntityIds: string[];
}

export interface InformationRequestComment {
  contactEntityId: string | null;
  userEntityId: string | null;
  authorFullName: string;
  createdOn: Date | string;
  comment: string;
}

export enum InformationRequestStatus {
  Open = 0,
  Resolved = 1,
  Closed = 2,
}

export function getInformationRequestStatusName(status: InformationRequestStatus | null) {
  switch (status) {
    case InformationRequestStatus.Open:
      return 'information-requests.status.open';
    case InformationRequestStatus.Resolved:
      return 'information-requests.status.resolved';
    case InformationRequestStatus.Closed:
      return 'information-requests.status.closed';
    default:
      return 'information-requests.status.unknown';
  }
}
